import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import styles from './CategoryCellRenderer.module.scss';

const cx = classNames.bind(styles);

const CategoryCellRenderer: DataItemFormatter<string> = ({ value: interestTagIds }): JSX.Element | null => {
  const isInterest = /(region|sector|^tag)/.test(interestTagIds);
  const isAnalyst = /(^analyst)/.test(interestTagIds);
  const isReport = /(^type-tag)/.test(interestTagIds);

  if (isInterest) {
    return <span className={cx('category')}>Interests</span>;
  }
  if (isAnalyst) {
    return <span className={cx('category')}>Analysts</span>;
  }
  if (isReport) {
    return <span className={cx('category')}>Reports</span>;
  }
  return null;
};

export default CategoryCellRenderer;
